export default __webpack_public_path__ + "/dist/images/footer-logo.82d58ec528d8195115587855958d9855.png";